// Partnr 2 is the default. For one release the old panel and editor stay one
// switch away: ?partnr=v1 for one page load, or localStorage['partnr-v2'] =
// 'off' for this browser. ?partnr=v2 and 'on' still force Partnr 2.
// docs/partnr-2/cleanup.md lists what goes once the escape hatch is removed.
export const PARTNR_V2_STORAGE_KEY = 'partnr-v2';

export function isPartnrV2Enabled(): boolean {
  try {
    const query = new URLSearchParams(window.location.search).get('partnr');
    if (query === 'v1') return false;
    if (query === 'v2') return true;
    return window.localStorage.getItem(PARTNR_V2_STORAGE_KEY) !== 'off';
  } catch {
    // No window (tests, SSR) or storage blocked: Partnr 2, the default
    return true;
  }
}
